<template lang="pug">
  transition(name="fade" :duration="300")
    div
      .notification(v-if="content.id" :class="classes")
        button.delete(@click="closeMessage")
        p(v-html="content.text")
        hr(v-if="content.info")
        div(v-if="content.info" v-html="content.info")
      // .message(v-if="this.content.type")
      //   .message-box.animated
      //     article.message(v-bind:class="'is-'+content.type")
      //       .message-header
      //         p {{ content.title }}
      //         button.delete(@click="closeMessage()" aria-label="")
      //       .message-body
      //         p {{ content.text }}
</template>

<script>

import store from '@/store'

let timeout

export default {
  name: 'Message',
  // props:['content'],
  props: {
    content: {
      type: Object,
      required: false
    },
    // closeMessage: {
    //  type: Function,
    //  required: false
    // }
  },
  watch: {
    'content.highlight': function(highlight) {
      if (highlight && timeout && this.content.autoclose) {
        clearTimeout(timeout)
        timeout = setTimeout(() => store.commit('removeMessage', this.content.id), this.content.autoclose)
      }
    }
  },
  computed: {
    classes() {
      let classes = {}

      classes[`is-${this.content.type}`] = true
      classes['focused'] = this.content.highlight

      return classes
    }
  },
  methods: {
    closeMessage() {
      store.commit('removeMessage', this.content.id)
      // this.content.title = ''
      // this.content.text = ''
      // this.content.type = null
      // this.content.autoclose = null
    }
  },
  // updated() {
  //   if (this.content.autoclose) {
  //     setTimeout(() => store.commit('removeMessage', this.content.id), this.content.autoclose)
  //   }
  // },
  mounted() {
    if (this.content.autoclose) {
      timeout = setTimeout(() => store.commit('removeMessage', this.content.id), this.content.autoclose)
    }
  },
}
</script>

<style lang="sass" scoped>

.fade-enter, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave
    opacity: 1
.notification
  // transition: transform 100ms ease-in-out
  transform-origin: 120px center
  &:before
    display: block
    position: absolute
    width: 20px
    height: 20px
    top: calc(50% - 10px)
    left: calc(100% + 20px)
    background-color: inherit
    border-radius: 29px
    transition: opacity .3s, transform .3s
    animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1)
    z-index: -1
  &.focused
    // transform: scale(1.05)
    animation: bounce 200ms cubic-bezier(0.24, 0, 0.38, 1)
    &:before
      // content: ''

  hr
    margin: 1.3rem 0
    opacity: 0.6
    height: 1px

  ::v-deep table
    margin-top: 10px
    td
      padding-right: 6px
      padding-bottom: 6px

</style>
